import React from "react";
import { Table } from "react-bootstrap";
import TooltipHelper from "../../../components/TooltipHelper";
import NoDataSkeleton from "../../../components/NoDataSkeleton";

interface DemoTableProps {
  data: App.PopulationDemoSegment[];
  demoType: "Race" | "Ethnicity";
  eventType: "Cases" | "Deaths" | "Tests";
  suppress: boolean;
  showPop: boolean;
}

export default function DemoTable(props: DemoTableProps) {
  const { data, demoType, eventType, suppress, showPop } = props;
  return (
    <Table responsive className="mb-5">
      <thead>
        <tr className="text-center bg-blue white">
          <th style={{ width: "50%" }} className="text-left">
            {demoType}
          </th>
          <th className="text-center">% of {eventType}</th>
          {showPop ? (
            <th className="text-center">% of Indiana Population</th>
          ) : null}
        </tr>
      </thead>
      <tbody>
        {!suppress ? (
          data.map((record) => (
            <tr key={record.name}>
              <td>
                {record.name}
                {record.name === "Other Race" ? (
                  <TooltipHelper
                    text={
                      "Other races Included: American Indian, Alaska Native, Native Hawaiian, Other Pacific Islander, two or more races, and those reported to IDOH as other race."
                    }
                  />
                ) : null}
              </td>
              <td className="text-center">
                {record.value ? record.value.toFixed(1) : record.value} %
              </td>
              {showPop ? (
                <td className="text-center">{record.population} %</td>
              ) : null}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={2}>
              <NoDataSkeleton />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
